// extracted by mini-css-extract-plugin
export var activitiesLoading = "search_app-module__activitiesLoading___FULlD";
export var breadcrumbEnter = "search_app-module__breadcrumbEnter___k81aL";
export var breadcrumbEnterActive = "search_app-module__breadcrumbEnterActive___xYWU8";
export var breadcrumbExit = "search_app-module__breadcrumbExit___cV8vx";
export var breadcrumbExitActive = "search_app-module__breadcrumbExitActive___xQ4Ji";
export var nullState = "search_app-module__nullState___i8O7r";
export var resultList = "search_app-module__resultList___WVIR3";
export var trailErrorFallbackContainer = "search_app-module__trailErrorFallbackContainer___SBPwX";